import { IItemForGetShortInfo, ITotalPrice } from 'types';
import React, { useCallback, useMemo } from 'react';
import MultipleSelect from './components/MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './IsPreselectedField.module.scss';

interface IIsPreselectedField {
	setPreselectedInRestaurants: (value: string[]) => void;
	isPreselectedInRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	totalPrices: ITotalPrice[];
}

const IsPreselectedField: React.FC<IIsPreselectedField> = ({
	isPreselectedInRestaurants,
	fetchedRestaurants,
	setPreselectedInRestaurants,
	totalPrices,
}) => {
	const handleRemove = useCallback(
		(id: string) => {
			const selectedItems = isPreselectedInRestaurants.filter((el) => el !== id);
			setPreselectedInRestaurants(selectedItems);
		},
		[isPreselectedInRestaurants, setPreselectedInRestaurants],
	);

	const restaurantsList = useMemo(() => {
		return isPreselectedInRestaurants.map((el) => {
			const label = fetchedRestaurants.find((rest) => rest.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [isPreselectedInRestaurants, fetchedRestaurants, handleRemove]);

	return (
		<div className={style.container} data-test="IsPreselectedField">
			<div className={style.field}>
				<MultipleSelect
					totalPrices={totalPrices}
					isPreselectedInRestaurants={isPreselectedInRestaurants}
					setPreselectedInRestaurants={setPreselectedInRestaurants}
				/>
			</div>
			<div className={style.restaurantsList}>{restaurantsList}</div>
		</div>
	);
};

export default React.memo(IsPreselectedField);
